import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { Observable } from 'rxjs';
import { ODataAdaptor } from '../adaptors/odata-adaptor';
import { FileDownloaderService } from '../common/file-downloader.service';
import { FactureListeForExport } from '../models/parametres-comptable/parametres-comptable';
import { ConfigService } from './config/config.service';
import { NotificationToastService } from './notifications/notification-toast.service';

@Injectable({
  providedIn: 'root',
})
export class ExportComptableService {
  private urlApi = this.configService.config.urlApi + '/api/fi/ExportComptable';
  private urlApiView = this.configService.config.urlApi + '/api/fi/ExportsComptablesView';

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient,
    private fileDownloaderService: FileDownloaderService,
    @Inject(LOCALE_ID) private locale: string,
    private notificationToastService: NotificationToastService,
    private oDataAdaptor: ODataAdaptor,
  ) { }

  buildDataManagerGetExportsComptables(): DataManager {
    return new DataManager({
      url: this.urlApiView,
      adaptor: this.oDataAdaptor,
    });
  }

  public getIsExportCorrect(idEntite: number): Observable<any> {
    return this.httpClient.get(`${this.urlApi}/GetParametrageCorrect/${idEntite}`);
  }

  public getFacturesToExport(idEntite: number, dateDebut: Date, dateFin: Date): Observable<any> {
    return this.httpClient.get<any>(
      `${this.urlApi}/GetFacturesAExporter?idEntite=${idEntite}&dateDebut=${this.formatDate(dateDebut)}&dateFin=${this.formatDate(dateFin, true)}`
    );
  }

  public exportFactures(factures: FactureListeForExport): Observable<any> {
    return this.httpClient.post(`${this.urlApi}/ExporterFactures`, factures);
  }

  public telechargerExport(idExport: number, defaultFilename?: string): Observable<void> {
    var defaultFilename = `Export_Comptable_${idExport}_${new DatePipe(this.locale).transform(Date(), 'dd-MM-yyyy')}.txt`;
    return this.fileDownloaderService.download(`${this.urlApi}/GetExportComptable/${idExport}`, defaultFilename);
  }

  private formatDate(date: Date, endOfDay = false): string {    
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return endOfDay ? `${y}-${m}-${d}T23:59:59` : `${y}-${m}-${d}T00:00:00`;
  }
}
